// src/plugins/sales-forecast/components/CloneControl.tsx
import React from "react";
import { useSystemTheme } from "../hooks/useSystemTheme";
import "../../sales-forecast/styles/theme.css";

interface CloneControlProps {
  cloneFlag: boolean;
  onToggle: () => void;
}

export const CloneControl: React.FC<CloneControlProps> = ({ cloneFlag, onToggle }) => {
  const theme = useSystemTheme();

  // Pull CSS theme variables (same as PredictControl / ResetControl)
  const textColor = "var(--text-color)";
  const accentColor = "var(--accent-color)";
  const inputBg = "var(--input-bg)";
  const borderColor = "var(--border-color)";

  // When toggled ON, the button sits in the "highlighted" state permanently
  // (accent background + white text), matching the hover look of the other buttons.
  const activeBg = accentColor;
  const activeColor = "#fff";
  const inactiveBg = inputBg;
  const inactiveColor = textColor;

  return (
    <button
      onClick={onToggle}
      aria-pressed={cloneFlag}
      className={`theme-${theme} transition-all duration-200 rounded-lg font-medium`}
      style={{
        backgroundColor: cloneFlag ? activeBg : inactiveBg,
        color: cloneFlag ? activeColor : inactiveColor,
        border: `1px solid ${borderColor}`,
        padding: "0.5rem 1rem",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        // On hover, always show the highlighted look for affordance
        e.currentTarget.style.backgroundColor = activeBg;
        e.currentTarget.style.color = activeColor;
      }}
      onMouseLeave={(e) => {
        // Snap back to whichever state the toggle is currently in
        e.currentTarget.style.backgroundColor = cloneFlag ? activeBg : inactiveBg;
        e.currentTarget.style.color = cloneFlag ? activeColor : inactiveColor;
      }}
    >
      Clone
    </button>
  );
};